module.exports = __webpack_public_path__ + "img/柳屯镇-c.484d1548.png";